import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { maskConfig, moneyMaskWithoutDecimal } from '@libraries/ui';
import { isDesktop, isMobile } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CalculateMonthlyCost,
  CloseActive,
  getAddressWithoutZip,
  getImprovementCost,
  getMonthlyCosts,
  getSelectedImprovement,
  isLoading,
  MonthlyCostInformation,
  RedirectToApplication,
} from '../../state';

@Component({
  templateUrl: './calculate-existing-improvement-monthly-cost.component.html',
  styleUrls: ['./calculate-existing-improvement-monthly-cost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalculateExistingImprovementMonthlyCostComponent implements OnInit {
  costForm: UntypedFormGroup;
  moneyMaskWithoutDecimal = moneyMaskWithoutDecimal;
  maskConfig = maskConfig;
  monthlyCosts$: Observable<MonthlyCostInformation[]> = this.store.pipe(select(getMonthlyCosts));
  estimatedCost$ = this.store.pipe(select(getImprovementCost));
  selectedImprovement$ = this.store.pipe(select(getSelectedImprovement));
  address$ = this.store.pipe(select(getAddressWithoutZip));
  isDesktop$ = this.store.pipe(select(isDesktop));
  isMobile$ = this.store.pipe(select(isMobile));
  isLoading$ = this.store.pipe(select(isLoading));
  showEstimatedCosts$ = new BehaviorSubject(false);

  buttonHandler$: Observable<any>;
  imageName$: Observable<string>;
  displayCalcCostsButton$: Observable<boolean>;
  showData$: Observable<boolean>;

  constructor(private fb: UntypedFormBuilder, private store: Store) {
    this.buttonHandler$ = combineLatest([this.isMobile$, this.showEstimatedCosts$]);

    this.imageName$ = this.buttonHandler$.pipe(
      map(([isMbl, showCosts]) => (isMbl && showCosts ? '' : 'estimatedCostsSuccess'))
    );

    this.displayCalcCostsButton$ = this.buttonHandler$.pipe(
      map(([isMbl, showcosts]) => isMbl && !showcosts)
    );

    this.showData$ = this.buttonHandler$.pipe(map(([isMbl, showcosts]) => !isMbl || showcosts));
  }

  ngOnInit(): void {
    this.costForm = this.fb.group({
      estimated_cost: [
        null,
        {
          updateOn: 'focus',
          validators: [Validators.required, Validators.min(5000), Validators.max(100000000)],
        },
      ],
    });
  }

  navigate() {
    this.store.dispatch(RedirectToApplication());
  }

  displayCalculatedCosts() {
    this.showEstimatedCosts$.next(true);
  }

  close() {
    this.store.dispatch(CloseActive());
  }

  submit() {
    this.costForm.markAllAsTouched();
    if (this.costForm.invalid) return;
    this.store.dispatch(CalculateMonthlyCost({ payload: this.costForm.value }));
  }
}
